import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=518ea38b&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "./Company.vue?vue&type=style&index=0&id=518ea38b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ea38b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518ea38b')) {
      api.createRecord('518ea38b', component.options)
    } else {
      api.reload('518ea38b', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=518ea38b&scoped=true&", function () {
      api.rerender('518ea38b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Settings/Company.vue"
export default component.exports